import { productConstants } from '../actions/constants';

const initialState = {
	products: [],
	priceRange: {},
	productsByPrice: {},
	pageRequest: false,
	page: {},
	error: null,
	productDetails: {},
	loading: false,
	allProducts: [],
	searchText: ''
};

export default (state = initialState, action) => {
	switch (action.type) {
		case productConstants.GET_PRODUCTS_BY_SLUG_SUCCESS:
			state = {
				...state,
				products: action.payload.products,
				priceRange: action.payload.priceRange,
				productsByPrice: {
					...action.payload.productsByPrice
				}
			};
			break;
		case productConstants.GET_PRODUCT_PAGE_REQUEST:
			state = {
				...state,
				pageRequest: true
			};
			break;
		case productConstants.GET_PRODUCT_PAGE_SUCCESS:
			state = {
				...state,
				page: action.payload.page,
				pageRequest: false
			};
			break;
		case productConstants.GET_PRODUCT_PAGE_FAILURE:
			state = {
				...state,
				error: action.payload.error,
				pageRequest: false
			};
			break;

		case productConstants.GET_PRODUCT_DETAILS_BY_ID_REQUEST:
			state = {
				...state,
				loading: true
			};
			break;
		case productConstants.GET_PRODUCT_DETAILS_BY_ID_SUCCESS:
			state = {
				...state,
				loading: false,
				productDetails: action.payload.productDetails
			};
			break;
		case productConstants.GET_PRODUCT_DETAILS_BY_ID_FAILURE:
			state = {
				...state,
				loading: false,
				error: action.payload.error
			};
			break;

		case productConstants.GET_ALL_PRODUCT_REQUEST:
			state = {
				...state,
				loading: true
			};
			break;
		case productConstants.GET_ALL_PRODUCT_SUCCESS:
			state = {
				...state,
				loading: false,
				allProducts: action.payload.products
			};
			break;
		case productConstants.GET_ALL_PRODUCT_FAILURE:
			state = {
				...state,
				loading: false,
				error: action.payload.error
			};
			break;
	}
	return state;
};
